// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"Dy-z","modalContent":"Ey-z","header":"Fy-z","close":"Gy-z"};